import update from 'immutability-helper';
import { get } from 'lodash';
import { persistenceKeys } from '@utils/persistenceUtil';
import * as types from './types';

function getInitialPersistenceStates() {
  const persistenceStates = {};

  persistenceKeys.forEach((key) => {
    persistenceStates[key] = {
      key: null,
      errorMessage: '',
      loading: true,
      skipGetAction: false,
      isFetched: false,
      response: null,
    };
  });

  return persistenceStates;
}

const initialState = {
  activePersistenceKey: '',
  persistenceData: getInitialPersistenceStates(),
};

const updateLoadingState = (state) => {
  const { activePersistenceKey } = state;

  if (activePersistenceKey) {
    const updatedState = update(state, {
      persistenceData: {
        [state.activePersistenceKey]: {
          loading: { $set: true },
        },
      },
    });

    return updatedState;
  }

  return state;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PERSISTENCE_KEY: {
      return update(state, {
        activePersistenceKey: { $set: action.persistenceKey },
      });
    }

    case types.GET_URL_PERSISTENT_CONFIGURATION: {
      return updateLoadingState(state);
    }

    case types.GET_URL_PERSISTENT_CONFIGURATION_SUCCESS: {
      const {
        response: { key, message },
      } = action;
      return update(state, {
        persistenceData: {
          [state.activePersistenceKey]: {
            key: { $set: key },
            loading: { $set: false },
            isFetched: { $set: true },
            response: { $set: action.response },
            message: { $set: message },
          },
        },
      });
    }

    case types.GET_URL_PERSISTENT_CONFIGURATION_FAIL:
      return update(state, {
        persistenceData: {
          [state.activePersistenceKey]: {
            errorMessage: {
              $set: action.errorMessage,
            },
            key: {
              $set: get(action, 'response.key', null),
            },
            loading: { $set: false },
            isFetched: { $set: false },
          },
        },
      });

    case types.UPDATE_URL_PERSISTENT_CONFIGURATION_SUCCESS: {
      return update(state, {
        persistenceData: {
          [state.activePersistenceKey]: {
            skipGetAction: { $set: false },
            response: { $set: action.response },
          },
        },
      });
    }

    case types.UPDATE_URL_PERSISTENT_CONFIGURATION_FAIL:
      return update(state, {
        persistenceData: {
          [state.activePersistenceKey]: {
            errorMessage: {
              $set: action.errorMessage,
            },
            skipGetAction: { $set: false },
          },
        },
      });

    case types.RESET_PERSISTENT_CONFIGURATION:
      return update(state, {
        persistenceData: {
          [state.activePersistenceKey]: {
            $set: { ...action.params },
          },
        },
      });

    case types.SET_LOADING_FALSE:
      return update(state, {
        persistenceData: {
          [state.activePersistenceKey]: {
            loading: { $set: false },
          },
        },
      });

    default:
      return state;
  }
};
